// Speaker-only feedback. Never attach this graph to the call's microphone or RTP sender.
const pairs={'1':[697,1209],'2':[697,1336],'3':[697,1477],'4':[770,1209],'5':[770,1336],'6':[770,1477],'7':[852,1209],'8':[852,1336],'9':[852,1477],'*':[941,1209],'0':[941,1336],'#':[941,1477]};
export function createKeypadFeedback(env=globalThis){
  let context,active=[],generation=0;
  const stop=()=>{for(const node of active){try{node.stop();}catch{}}active=[];};
  return {
    async play(digit){
      const frequencies=pairs[digit];if(!frequencies)return false;
      const token=++generation;
      try{
        const Audio=env.AudioContext||env.webkitAudioContext;if(!Audio)return false;
        if(!context||context.state==='closed')context=new Audio();
        if(context.state!=='running')await context.resume();
        if(token!==generation||context.state!=='running')return false;
        stop();const start=context.currentTime,gain=context.createGain();
        gain.gain.setValueAtTime(0,start);gain.gain.linearRampToValueAtTime(0.06,start+0.005);gain.gain.setValueAtTime(0.06,start+0.10);gain.gain.linearRampToValueAtTime(0,start+0.12);
        gain.connect(context.destination);let remaining=2;
        active=frequencies.map(frequency=>{const node=context.createOscillator();node.type='sine';node.frequency.setValueAtTime(frequency,start);node.connect(gain);node.onended=()=>{node.disconnect();if(!--remaining)gain.disconnect();};node.start(start);node.stop(start+0.13);return node;});
        return true;
      }catch{return false;} // Feedback failure must not interfere with sending digits.
    },
    stop(){++generation;stop();},
    async close(){++generation;stop();if(context){try{await context.close();}catch{}context=null;}}
  };
}
